import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Choices are hard...
        </p>
        <p>
          Let our <code>algorithms</code> choose for you.
        </p>
        <h1>
          TENDERS
        </h1>
      </header>
    </div>
  );
}

export default App;
